import axios from 'axios'
import sysConfig from '@/config/config'

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: sysConfig.PHP_URL,
  // 超时
  timeout: 60000
})
// request拦截器
service.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = 'application/json'
    if (config.method === 'post') {
      // 如果是POST请求，添加默认参数到请求体
      config.data = {
        ...config.data,
        version: sysConfig.PHP_API_VERSION
      }
    } else {
      // 如果是其他类型的请求，添加默认参数到URL
      config.params = {
        ...config.params,
        version: sysConfig.PHP_API_VERSION
      }
    }
    // console.log('config', config)
    return config
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  res => {
    // console.log('res:', res)
    if (res.status === 200 && res.data.code === 1) {
      return res.data
    }
    if (res.data.code === 3001) {
      // uni.showToast({
      //   icon: 'none',
      //   title: '登录过期，请重新登录',
      //   mask: true
      // })
    } else {
      let msg = ''
      if (!res.data.msg) {
        msg = '未知错误'
      } else {
        msg = res.data.msg
      }
      // uni.showToast({
      //   icon: 'none',
      //   title: msg
      // })
      return Promise.reject(res.data)
    }
  },
  error => {
    console.log('err' + error)
    // uni.showToast({
    //   icon: 'none',
    //   title: err.msg
    // })
    return Promise.reject(error)
  }
)

export function getList(data) {
  return service({
    url: '/WebToday/index_list',
    method: 'post',
    data: data
  })
}

export function publish(data) {
  return service({
    url: '/WebToday/publish',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/appApi.js